import React, { useEffect, useState } from 'react';
import { FileText, Phone } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) setIsVisible(true);else setIsVisible(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 md:hidden flex gap-3" data-id="element-430">
      <a href="#quote" className="flex-1 bg-brand-blue text-white font-bold py-3 px-4 rounded-xl text-center flex items-center justify-center gap-2 text-sm" data-id="element-431">
        <FileText className="w-4 h-4" data-id="element-432" />
        Free Quote
      </a>
      <a href="tel:517-545-7772" className="flex-1 bg-white border-2 border-brand-blue text-brand-blue font-bold py-3 px-4 rounded-xl text-center flex items-center justify-center gap-2 text-sm" data-id="element-433">
        <Phone className="w-4 h-4" data-id="element-434" />
        Call Now
      </a>
    </div>;
}